/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Copy_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Activation code copied to clipboard successfully." |
*
* @param {Offline_Activation_Copy_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_copy_success_toast = /** @type {((inputs?: Offline_Activation_Copy_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Copy_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'activation copie dans le presse-papiers avec succes.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierungscode erfolgreich in die Zwischenablage kopiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice di attivazione copiato correttamente negli appunti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код активации успешно скопирован в буфер обмена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de activación copiado al portapapeles exitosamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活码已成功复制到剪贴板。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーション コードがクリップボードに正常にコピーされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्टिवेशन कोड सफलतापूर्वक क्लिपबोर्ड पर कॉपी हो गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de ativação copiado com sucesso para a área de transferência.")
	return /** @type {LocalizedString} */ ("Activation code copied to clipboard successfully.")
});